export default "__VITE_ASSET__6889b5a3__"